export default __webpack_public_path__ + "static/media/YAS0120.34I-27678_-16600_0.df96d8bc.jpg";